import {Avatar, Button, Radio} from 'antd'
import {auth_getMyChannels_Api} from 'apis'
import EmptyHolder from 'components/EmptyHolder'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import CustomLazyPaginationWrapper from 'modules/asyncCache/components/CustomLazyPaginationWrapper'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useState} from 'react'
import {GiIronCross} from 'react-icons/gi'
import {RiAddFill, RiSignalTowerFill} from 'react-icons/ri'
import {Link} from 'react-router-dom'
import {staticPaths} from 'routes/staticPaths'
import {renderIf, renderIfElse} from '../../Shared'
import renderPagingLoading from '../functions/renderPagingLoading'
import ChannelsByAuth from './components/ChannelsByAuth'
import './Radio.css'
import classNames from "classnames";
import {getType} from "../../../apis/model/base";
import getAvatar from "../../../helpers/getAvatar";
import {BiSolidChurch} from "react-icons/bi";
import {BsPersonFill} from "react-icons/bs";
import _ from 'lodash'
import {FollowButton} from "../../../components/Feed/FollowButton";
import {HeaderBlock} from "../components/HeaderBlock";

const renderItem = ({type}) => (item, index) => {
    const {owner, description, total_articles, total_followers} = item ?? {}
    const categories = Array.from(item?.categories ?? [])

    return (
        <Translate>
            {(t) => (
                <div key={index} className="p-2 flex flex-col gap-1 background border-t border-color-50 shadow-md hover:scale-2xs rounded-xl cursor-pointer">
                    <div className="flex items-center gap-3">
                        <Avatar
                            size={38}
                            shape={getType(owner) === 'organization' ? 'square' : 'circle'}
                            className={classNames('flex flex-center background-200', getType(owner) === 'organization' && 'rounded-md')}
                            icon={
                                getType(owner) === 'organization' ?
                                    <BiSolidChurch size={20} className="text-color-500"/> :
                                    getType(owner) === 'user' ? <BsPersonFill size={20} className="text-color-500"/> :
                                        <RiSignalTowerFill size={20} className="text-color-500"/>
                            }
                            src={getAvatar(owner)}
                        />
                        <div className="flex flex-col">
                            <Link
                                to={getLinkToDetail(item)}
                                className="font-bold text-color-000 flex-1 no-underline leading-snug">
                                {getTitle(item)}
                            </Link>
                            {owner && (
                                <div className="space-x-1 text-xs italic leading-tight">
                                    <span className="text-color-400 tracking-wider whitespace-no-wrap">
                                        {t('owner')}
                                    </span>
                                    <Link
                                        rel="nofollow"
                                        to={getLinkToDetail(owner)}
                                        className="font-semibold text-blue-500 tracking-wide no-underline truncate">
                                        {getTitle(owner)}
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                    {renderIf(
                        categories.length,
                        <div className="flex flex-wrap gap-x-3 gap-y-1">
                            {categories.map((category, index) => (
                                <div
                                    key={index}
                                    className="flex items-center text-primary">
                                    <GiIronCross size={8} className="mr-1"/>
                                    <span className="italic font-medium text-xs">
                                        {category?.name}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                    {renderIf(
                        description,
                        <div className="ml-3 text-sm text-color-300 tracking-wider">{description}</div>
                    )}
                    <div className="flex items-center justify-between gap-3">
                        {renderIfElse(
                            _.some([total_followers, total_articles]),
                            <div className="mt-1 ml-3 flex flex-1 gap-6">
                                {renderIf(
                                    total_followers,
                                    <div className="flex items-baseline text-sm gap-1 leading-tight">
                                        <span className="font-medium text-color-000">
                                          {total_followers}
                                        </span>
                                        <span className="text-xs italic text-color-300">
                                            {t('members')}
                                        </span>
                                    </div>
                                )}
                                {renderIf(
                                    total_articles,
                                    <div className="flex items-baseline text-sm gap-1 leading-tight">
                                        <span className="font-medium text-color-000">
                                          {total_articles}
                                        </span>
                                        <span className="text-xs italic text-color-300">
                                            {t('articles')}
                                        </span>
                                    </div>
                                )}
                            </div>,
                            <div className="flex-1"/>
                        )}
                        {renderIf(
                            type === 'follow',
                            <FollowButton item={item} size="small" />
                        )}
                    </div>
                </div>
            )}
        </Translate>
    )
}

const MyChannels = () => {
    const t = useTranslate()
    const history = useHistory()
    const [type, setType] = useState('admin')

    const {isSm} = useContext(LayoutContext)

    const apiInfo = auth_getMyChannels_Api

    const lookupKey = [apiInfo.path, `type=${type}`].join('/')

    return (
        <div className="flex flex-col gap-3 h-full">
            <div className="w-full flex items-center">
                <div className="flex-1"/>
                <div className="flex items-center gap-3">
                    <Button
                        style={{height: 30, padding: '2px 10px', border: 0}}
                        onClick={() => {
                            history.push(staticPaths.createChannel)
                        }}
                        type="primary"
                        className="button-rounded-md flex flex-center gap-2 font-semibold text-sm">
                        <RiAddFill size={15}/>
                        {t('create channel')}
                    </Button>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="col-span-1 md:col-span-2 flex flex-col gap-4">
                    <div className="flex items-center w-full">
                        <Radio.Group
                            defaultValue={type}
                            onChange={(e) => setType(e.target.value)}
                            optionType="button"
                            buttonStyle="solid"
                            className="discovery-radio-group">
                            <Radio.Button value="owner">
                                {t('owner')}
                            </Radio.Button>
                            <Radio.Button value="admin">
                                {t('admin')}
                            </Radio.Button>
                            <Radio.Button value="follow">
                                {t('followed')}
                            </Radio.Button>
                        </Radio.Group>
                    </div>
                    <CustomLazyPaginationWrapper
                        id={lookupKey}
                        key={lookupKey}
                        alwaysVisible={true}
                        apiInfo={apiInfo}
                        values={{filter: type}}
                        renderEmpty={() => <EmptyHolder/>}
                        renderLoading={renderPagingLoading}
                        renderItem={renderItem({type: type})}
                    />
                </div>
                <div className="col-span-1 flex flex-col gap-4">
                    <ChannelsByAuth
                        alwaysVisible={true}
                        renderWrap={({children}) => (
                            <div className="flex flex-col gap-4">
                                <HeaderBlock
                                    size={26}
                                    icon={<RiSignalTowerFill size={14} className="text-color-500"/>}
                                    title="suggested channels"
                                    className="background-200 text-sm text-color-300"
                                />
                                {children}
                            </div>
                        )}
                    />
                </div>
            </div>
        </div>
    )
}

export default MyChannels
